/* global axios */
import ApiClient from './ApiClient';

class DealLabelsAPI extends ApiClient {
  constructor() {
    super('deal_labels', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(label) {
    return axios.post(this.url, label);
  }

  update(id, label) {
    return axios.patch(`${this.url}/${id}`, label);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getDealLabels(dealId) {
    return axios.get(`${super.baseUrl()}/deals/${dealId}/labels`);
  }

  updateDealLabels(dealId, labels) {
    return axios.post(`${super.baseUrl()}/deals/${dealId}/labels`, {
      labels,
    });
  }
}

export default new DealLabelsAPI();
